export default "__VITE_ASSET__NR$YwaiR__"